export const getCalculatedInvestmentPercent = (
  totalInvestment: number,
  totalInvestmentChange: number
): string => {
  if (totalInvestment === 0) return `100%`;
  const calculatedPercentage = (totalInvestmentChange / totalInvestment) * 100;
  const ceiledPercentage = Math.ceil(calculatedPercentage);
  return `${!!ceiledPercentage ? ceiledPercentage : 0}%`;
};
